import React from "react";
import { Form, Button, Modal } from "react-bootstrap";

import _ from "underscore";

const RobMdl = ({ handleClose, show }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      size="lg"
      centered
    >
      <Form width="100%">
        <Modal.Header closeButton>
          <Modal.Title className="text-success">
            <i className="fa fa-info-circle"></i> Robot Reviewer Score
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We have worked with RobotReviewer{" "}
            <a href="https://www.robotreviewer.net/" target="_blank">
              https://www.robotreviewer.net/{" "}
            </a>
            to automatically estimate the quality of clinical trials. <br></br>
          </p>
          <p>
            In using this score it is important to understand the process, so we
            recommend you read the explainer{" "}
            <a
              href="https://blog.tripdatabase.com/2023/05/17/introducing-our-rct-score/"
              target="_blank"
            >
              {" "}
              'Introducing our RCT score'
            </a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RobMdl;
